const STORAGE_KEY = "marketplace-dashboard-dismissals-v1";

function readStore() {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" && !Array.isArray(parsed)
      ? parsed
      : {};
  } catch {
    return {};
  }
}

function writeStore(store) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
}

function userKey(sub, perspective) {
  return `${String(sub ?? "anonymous")}:${perspective}`;
}

/**
 * @param {string|null|undefined} sub
 * @param {"customer"|"provider"} perspective
 * @param {string|number} orderId
 */
export function recordLocalDashboardDismissal(sub, perspective, orderId) {
  const key = userKey(sub, perspective);
  const store = readStore();
  const existing = Array.isArray(store[key]) ? store[key] : [];
  const id = String(orderId ?? "");
  if (!id || existing.includes(id)) {
    return;
  }
  store[key] = [...existing, id];
  writeStore(store);
}

/**
 * @param {string|null|undefined} sub
 * @param {"customer"|"provider"} perspective
 * @param {string|number|null|undefined} orderId
 */
export function isLocallyDismissedFromDashboard(sub, perspective, orderId) {
  const id = String(orderId ?? "");
  if (!id) return false;
  const key = userKey(sub, perspective);
  const store = readStore();
  const ids = store[key];
  return Array.isArray(ids) && ids.includes(id);
}
